import S, { DataSignal } from "s-js";
import * as Surplus from "surplus";
import "./Transient.scss";

const MIN_LOADING_TIME = 600;

type TransientProps<
    T extends { isLoading: DataSignal<boolean> },
    U extends { isLoading: DataSignal<boolean> },
> = {
    state: T;
    compLoader?: JSX.Element | null;
    comp: (state: U) => JSX.Element | JSX.Element[] | null;
};

/** Component used to represent multiple transient loading states */
export function Transient<
    T extends { isLoading: DataSignal<boolean> },
    U extends T & { isLoading: DataSignal<false> },
>(props: TransientProps<T, U>) {
    const loader = props.compLoader !== undefined ? props.compLoader : <BasicPreloader />;
    const debounceIsLoading = S.value(true);
    const start = Date.now();
    S.on(props.state.isLoading, () => {
        if (!props.state.isLoading()) {
            const diff = Date.now() - start;
            if (diff < MIN_LOADING_TIME) {
                setTimeout(() => {
                    debounceIsLoading(false);
                }, MIN_LOADING_TIME - diff);
            } else {
                debounceIsLoading(false);
            }
        } else {
            debounceIsLoading(true);
        }
    });
    return S(() => {
        return debounceIsLoading() ? loader : props.comp(props.state as any);
    }) as any as JSX.Element;
}

function BasicPreloader() {
    return (
        <div class="preloaderBasicContainer">
            <div class="preloaderBasicContent" />
        </div>
    );
}

export function EllipsisPreloader(props: { isLoading: DataSignal<boolean> }) {
    const loadingText = S.data("");
    let loadAnimationHandle = -1;
    let animationStart = -1;

    S(() => {
        if (props.isLoading()) {
            animationStart = window.setTimeout(() => {
                loadAnimationHandle = window.setInterval(() => {
                    switch (loadingText()) {
                        case ".":
                            loadingText("..");
                            break;
                        case "..":
                            loadingText("...");
                            break;
                        case "":
                        case "...":
                            loadingText(".");
                            break;
                    }
                }, 350);
            });

            S.cleanup(() => {
                clearTimeout(animationStart);
                clearInterval(loadAnimationHandle);
            });
        }
    });
    return <div class="preloaderEllipsis">{loadingText()}</div>;
}
